import "./reviews-style.css";
import {Swiper, SwiperSlide} from "swiper/react";
import {ReviewProps} from "./ReviewProps";
import {ReviewContent} from "./ReviewContent";
import {SliderReviewConfig} from "./SliderReviewConfig";
import {useState} from "react";
import {ReviewModal} from "../modal/review/ReviewModal";
import {ToastContainer} from "react-toastify";
export const Reviews = (reviews: ReviewProps) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            <section className={"Reviews"} id={'reviews'}>
                <div className={'container'}>
                    <h1 className={'section__title'}>Отзывы заботливых родителей</h1>
                    <Swiper className={'review__slide'} {...SliderReviewConfig}>
                        {reviews.review.map((slide, index) => (
                            <SwiperSlide key={index} className={'review__slide'}>
                                <ReviewContent {...slide} />
                            </SwiperSlide>
                        ))}
                        <div className="swiper-button-prev"></div>
                        <div className="swiper-button-next"></div>
                    </Swiper>
                    <div className="review__btn-wrap">
                        <button type="button" onClick={openModal} className="btn btn-review">Оставить отзыв</button>
                    </div>
                </div>

            </section>
            <ReviewModal isOpen={isModalOpen} onClose={closeModal}/>
            <ToastContainer/>
        </>
    );
}